import DashboardLayout from 'src/pages/Dashboard/Layout/DashboardLayout.vue'
import Guard from './middleware'
import Informes from 'src/pages/Dashboard/Informes/Informes.vue'
import VentasNegocios from 'src/pages/Dashboard/Informes/Ventas/VentasNegocios.vue'
import VentasProductosNegocios from 'src/pages/Dashboard/Informes/Productos/VentasNegocios.vue'
import ComprasNegocios from 'src/pages/Dashboard/Informes/Casas/ComprasNegocio.vue'
import ComprasCasas from 'src/pages/Dashboard/Informes/Casas/ComprasCasas.vue'
import GastosProveedor from 'src/pages/Dashboard/Informes/Proveedores/GastosProveedor.vue'
import GastosSubproductos from 'src/pages/Dashboard/Informes/Subproductos/GastosSubproductos.vue'
import GastosPorProveedor from 'src/pages/Dashboard/Informes/Proveedores/GastosPorProveedor.vue'
import VentasProductos from 'src/pages/Dashboard/Informes/Productos/VentasProductos.vue'
import VentasTotalProductos from 'src/pages/Dashboard/Informes/Productos/VentasTotalProducto.vue'
import VentasPorOperarios from 'src/pages/Dashboard/Informes/Operarios/VentasPorOperarios.vue'
import AperturasPorOperarios from 'src/pages/Dashboard/Informes/Operarios/AperturasPorOperarios.vue'
import VentasClientes from 'src/pages/Dashboard/Informes/Clientes/VentasClientes.vue'
import CuentasAparcadas from 'src/pages/Dashboard/Informes/Ventas/CuentasAparcadas.vue'
import FacturasEmitidas from 'src/pages/Dashboard/Informes/Ventas/FacturasEmitidas.vue'
import FacturasEmitidasQR from 'src/pages/Dashboard/Informes/Ventas/FacturasEmitidasQR.vue'
import FormasPago from 'src/pages/Dashboard/Informes/Ventas/FormasPago.vue'
import EstadisticaAgencia from 'src/pages/Dashboard/Informes/Ventas/EstadisticaAgencia.vue'
import Tickets from 'src/pages/Dashboard/Informes/Ventas/Tickets.vue'
import FacturacionGeneral from 'src/pages/Dashboard/Informes/Ventas/FacturacionGeneral.vue'
import DesglosesImpuestos from 'src/pages/Dashboard/Informes/Ventas/DesglosesImpuestos.vue'
import CierresCaja from 'src/pages/Dashboard/Informes/Ventas/CierresCaja.vue'
import InformePedidosDetalle from 'src/pages/Dashboard/Informes/Pedidos/InformePedidosDetalle.vue'
import InformePedidos from 'src/pages/Dashboard/Informes/Pedidos/InformePedidos.vue'
import InformeVentasProductosPedidos from 'src/pages/Dashboard/Informes/Pedidos/InformeVentasProductosPedidos.vue'
import GastosCasas from 'src/pages/Dashboard/Informes/Casas/GastosCasas.vue'
import VentasDispositivos from 'src/pages/Dashboard/Informes/Marshall/VentasDispositivos.vue'
import VentasCategorias from 'src/pages/Dashboard/Informes/Categorias/VentasCategorias.vue'
import EstadisticasAvanzadas from 'src/pages/Dashboard/Informes/Productos/EstadisticasAvanzadas.vue'
import EstadisticasAvanzadasAgencias from 'src/pages/Dashboard/Informes/Productos/EstadisticasAvanzadasAgencias.vue'
import GastosPorEtiqueta from 'src/pages/Dashboard/Informes/Proveedores/GastosPorEtiqueta.vue'
import Invitaciones from 'src/pages/Dashboard/Informes/Productos/Invitaciones.vue'
import TurnosOperarios from 'src/pages/Dashboard/Informes/Operarios/TurnosOperarios.vue'
//import TurnosOperariosExternalLink from 'src/pages/Dashboard/Informes/Operarios/TurnosOperariosExternalLink.vue'
import VentasPorComensales from 'src/pages/Dashboard/Informes/Ventas/VentasPorComensales.vue'
import VentasAnuladas from 'src/pages/Dashboard/Informes/Ventas/VentasAnuladas.vue'
import VentasZonaHoraria from 'src/pages/Dashboard/Informes/Ventas/VentasZonaHoraria.vue'
import VentasRangoMesas from 'src/pages/Dashboard/Informes/Ventas/VentasRangoMesas.vue'
import VentasProductosPorOperarios from 'src/pages/Dashboard/Informes/Operarios/VentasProductosPorOperarios.vue'
import AperturasProductosPorOperarios from 'src/pages/Dashboard/Informes/Operarios/AperturasProductosPorOperarios.vue'
import HistoricoProductos from 'src/pages/Dashboard/Informes/Productos/HistoricoProductos.vue'
import TiempoMedioPreparacion from 'src/pages/Dashboard/Informes/KDS/TiempoMedioPreparacion.vue'
import ConsultarVentasCliente from 'src/pages/Dashboard/Informes/Clientes/ConsultarVentasCliente.vue'
import ConsultarVentasProductosCliente from 'src/pages/Dashboard/Informes/Clientes/ConsultarVentasProductosCliente.vue'
import RegistrosHorarios from 'src/pages/Dashboard/Informes/Operarios/RegistrosHorarios.vue'
import VentasSubproductos from 'src/pages/Dashboard/Informes/Subproductos/VentasSubproductos.vue'
import consultarInventarioPorSectores from 'src/pages/Dashboard/Informes/Subproductos/consultarInventarioPorSectores.vue'
import VentasRectificadas from 'src/pages/Dashboard/Informes/Ventas/VentasRectificadas.vue'
import Retiradas from 'src/pages/Dashboard/Informes/Ventas/Retiradas.vue'
import VentasCategoriaClientes from 'src/pages/Dashboard/Informes/Clientes/VentasCategoriaClientes.vue'
import PedidosFormasPago from 'src/pages/Dashboard/Informes/Pedidos/PedidosFormasPago.vue'
import PedidosFormasPagoRedsys from 'src/pages/Dashboard/Informes/Pedidos/PedidosFormasPagoRedsys.vue'
import PedidosArchivados from 'src/pages/Dashboard/Informes/Pedidos/PedidosArchivados.vue'
import AsientoContable from 'src/pages/Dashboard/Informes/Sage/AsientoContable.vue'
import PlanDeCuentas from 'src/pages/Dashboard/Informes/Sage/PlanDeCuentas.vue'
import Efectos from 'src/pages/Dashboard/Informes/Sage/Efectos.vue'
import Clientes from 'src/pages/Dashboard/Informes/Sage/Clientes.vue'
import IncideciasPorOperarios from 'src/pages/Dashboard/Informes/Operarios/IncidenciasbyOperarios.vue'
import IncideciasPorOperario from 'src/pages/Dashboard/Informes/Operarios/IncidenciasbyOperario.vue'
import VentasProductosPorRangoDeMesas from 'src/pages/Dashboard/Informes/Productos/VentasProductosPorRangoDeMesas.vue'
import PedidosRepartidores from 'src/pages/Dashboard/Informes/Pedidos/PedidosRepartidores.vue'
import ListadoTicketRepartidor from 'src/pages/Dashboard/Informes/Pedidos/ListadoTicketRepartidor.vue'
// import TiempoMedioProducto from 'src/pages/Dashboard/Informes/KDS/TiempoMedioProducto.vue'

import Vales from 'src/pages/Dashboard/Informes/Ventas/Widgets/Vales.vue'



export default {
    path: '/informes',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    
    /*
    beforeEnter: (to, from, next) => {
        // Excluir la ruta del enlace externo del guard de autenticación
        if (to.name === 'turnos-operarios-external-link') {
            next(); // Permitir acceso sin autenticación
        } else {
            Guard.auth(to, from, next); // Aplicar autenticación para otras rutas
        }
    },
    */
    
    
    children: [
        {
            path: '/',
            name: 'informes',
            component: Informes
        },
        {
            path: 'ventas/ventas-negocios',
            name: 'ventas-negocios',
            component: VentasNegocios
        },
        {
            path: 'ventas/ventas-negocios-zona-horaria',
            name: 'ventas-negocios-zona-horaria',
            component: VentasZonaHoraria
        },
        {
            path: 'ventas/ventas-negocios-rango-mesas',
            name: 'ventas-negocios-rango-mesas',
            component: VentasRangoMesas
        },
        // {
        //     path: 'cocina/tiempo-medio-preparacion-producto',
        //     name: 'cocina-tiempo-medio-preparacion-producto',
        //     component: TiempoMedioProducto
        // },
        {
            path: 'cocina/tiempo-medio-preparacion',
            name: 'cocina-tiempo-medio-preparacion',
            component: TiempoMedioPreparacion
        },
        {
            path: 'ventas/ventas-anuladas',
            name: 'ventas-anuladas',
            component: VentasAnuladas
        },
        {
            path: 'ventas/retiradas',
            name: 'retiradas',
            component: Retiradas
        },
        {
            path: 'productos/ventas-negocios',
            name: 'ventas-productos-negocios',
            component: VentasProductosNegocios
        },
        {
            path: 'materias-primas/ventas-materias-primas',
            name: 'ventas-materias-primas-negocios',
            component: VentasSubproductos
        },
        {
            path: 'ventas/facturas-simplificadas/buscar/:query',
            name: 'search-facturas-simplificadas',
            component: Tickets
        },
        {
            path: 'casas/gastos-casas',
            name: 'compras-negocios',
            component: ComprasNegocios
        },
        {
            path: 'casas/compras-casas',
            name: 'compras-casas',
            component: ComprasCasas
        },
        {
            path: 'proveedores/gastos-etiquetas',
            name: 'gastos-etiquetas',
            component: GastosPorEtiqueta
        },
        {
            path: 'proveedores/gastos-proveedores',
            name: 'gastos-proveedor',
            component: GastosProveedor
        },
        {
            path: 'proveedores/gastos-general-proveedor',
            name: 'gastos-general-proveedor',
            component: GastosPorProveedor
        },
        {
            path: 'materias-primas/gastos-materias-primas/:idBusiness?/:pag?',
            name: 'gastos-materias-primas',
            component: GastosSubproductos
        },
        {
            path: 'materias-primas/gastos-materias-primas/buscar/:query',
            name: 'search-gastos-materias-primas',
            component: GastosSubproductos
        },
        {
            path: 'materias-primas/consultar-inventario-por-sectores',
            name: 'consultar-inventario-por-sectores',
            component: consultarInventarioPorSectores
        },
        {
            path: 'productos/ventas-productos',
            name: 'ventas-productos',
            component: VentasProductos
        },
        {
            path: 'productos/ventas-productos-por-rango-de-mesas',
            name: 'ventas-productos-por-rango-de-mesas',
            component: VentasProductosPorRangoDeMesas
        },
        {
            path: 'productos/historico-productos',
            name: 'historico-productos',
            component: HistoricoProductos
        },
        {
            path: 'productos/coste-productos',
            name: 'ventas-avanzadas-productos',
            component: EstadisticasAvanzadas
        },
        {
            path: 'productos/coste-productos-agencias',
            name: 'ventas-avanzadas-productos-agencias',
            component: EstadisticasAvanzadasAgencias
        },
        {
            path: 'productos/ventas-productos-global',
            name: 'ventas-total-productos',
            component: VentasTotalProductos
        },
        {
            path: 'operarios/ventas-operarios',
            name: 'ventas-operarios',
            component: VentasPorOperarios
        },
        {
            path: 'operarios/aperturas-operarios',
            name: 'aperturas-operarios',
            component: AperturasPorOperarios
        },
        {
            path: 'operarios/turnos-operarios',
            name: 'turnos-operarios',
            component: TurnosOperarios
        },
        /*
        {
            path: 'operarios/turnos-operarios-external-link/:hash',
            name: 'turnos-operarios-external-link',
            component: TurnosOperariosExternalLink,
            props: true, // Habilita el paso del parámetro :hash como prop al componente
        },
        */
        
        
        
        {
            path: 'operarios/registros-horarios',
            name: 'registros-horarios',
            component: RegistrosHorarios
        },
        {
            path: 'operarios/ventas-productos-operarios/:idBusiness?/:idWorker?',
            name: 'ventas-productos-operarios',
            component: VentasProductosPorOperarios
        },
        {
            path: 'operarios/aperturas-productos-operarios/:idBusiness?/:idWorkerOpen?',
            name: 'aperturas-productos-operarios',
            component: AperturasProductosPorOperarios
        },
        {
            path: 'operarios/incidencias-operarios',
            name: 'incidencias-operarios',
            component: IncideciasPorOperarios
        },
        {
            path: 'operarios/incidencias-operario/:idBusiness?/:nameWorker?',
            name: 'incidencias-operario',
            component: IncideciasPorOperario
        },
        {
            path: 'clientes/ventas-categoria-clientes',
            name: 'ventas-categoria-clientes',
            component: VentasCategoriaClientes
        },
        {
            path: 'clientes/ventas-clientes',
            name: 'ventas-clientes',
            component: VentasClientes
        },
        {
            path: 'clientes/consultar-ventas-clientes',
            name: 'consultar-ventas-clientes',
            component: ConsultarVentasCliente
        },
        {
            path: 'clientes/consultar-ventas-productos-cliente',
            name: 'consultar-ventas-productos-cliente',
            component: ConsultarVentasProductosCliente
        },
        {
            path: 'ventas/cuentas-aparcadas',
            name: 'cuentas-aparcadas',
            component: CuentasAparcadas
        },
        {
            path: 'ventas/facturas-nominativas',
            name: 'facturas-emitidas',
            component: FacturasEmitidas
        },
        {
            path: 'ventas/facturas-nominativas-qr',
            name: 'facturas-emitidas-qr',
            component: FacturasEmitidasQR
        },
        {
            // path: 'ventas/informe-pedidos-detalle/:idDay?/:idBusiness?',
            path: 'ventas/informe-pedidos-detalle/:idDay?/:idBusiness?/:datefrom?/:dateto?/:hoursfrom?/:hoursto?',
            name: 'informe-pedidos-detalle',
            component: InformePedidosDetalle
        },

        {
            path: 'ventas/informe-pedidos',
            name: 'informe-pedidos',
            component: InformePedidos
        },

        {
            path: 'ventas/informe-ventas-productos-pedidos',
            name: 'informe-ventas-productos-pedidos',
            component: InformeVentasProductosPedidos
        },

        {
            path: 'ventas/formas-pago',
            name: 'formas-pago',
            component: FormasPago
        },
        {
            path: 'categorias/ventas-categorias',
            name: 'ventas-categorias',
            component: VentasCategorias
        },
        {
            path: 'ventas/agencias',
            name: 'estadistica-agencia',
            component: EstadisticaAgencia
        },
        {
            path: 'ventas/facturas-simplificadas/:idBusiness?/:pag?',
            name: 'tickets',
            component: Tickets
        },
        {
            path: 'ventas/facturacion-general/:idBusiness?/:pag?',
            name: 'facturacion-general',
            component: FacturacionGeneral
        },
        {
            path: 'ventas/impuestos-cierre',
            name: 'desgloses-impuestos',
            component: DesglosesImpuestos
        },
        {
            path: 'ventas/ventas-comensales',
            name: 'ventas-comensales',
            component: VentasPorComensales
        },
        {
            path: 'ventas/cierres-caja',
            name: 'cierres-caja',
            component: CierresCaja
        },
        {
            path: 'casas/gastos',
            name: 'gastos-casas',
            component: GastosCasas
        },
        {
            path: 'ventas/dispositivo',
            name: 'ventas-dispositivo',
            component: VentasDispositivos
        },
        {
            path: 'productos/invitaciones',
            name: 'invitaciones',
            component: Invitaciones
        },
        {
            path: 'ventas/ventas-rectificadas',
            name: 'ventas-rectificadas',
            component: VentasRectificadas
        },
        {
            path: 'pedidos/pedidos-pasarela-pago',
            name: 'pedidos-pasarela-pago',
            component: PedidosFormasPago
        },
        {
            path: 'pedidos/pedidos-pasarela-pago-redsys',
            name: 'pedidos-pasarela-pago-redsys',
            component: PedidosFormasPagoRedsys
        },
        {
            path: 'pedidos/pedidos-archivados/:pag?',
            name: 'pedidos-archivados',
            component: PedidosArchivados
        },
        {
            path: 'pedidos/pedidos-repartidores',
            name: 'pedidos-repartidores',
            component: PedidosRepartidores
        },
        // {
        //     path: '/listado-ticket-repartidor/', 
        //     name: 'listado-ticket-repartidor',
        //     component: ListadoTicketRepartidor 
        // },
        /*{
            path: 'sage/asiento-contable',
            name: 'asiento-contable',
            component: AsientoContable
        },*/
        /*{
            path: 'sage/plan-de-cuentas',
            name: 'plan-de-cuentas',
            component: PlanDeCuentas
        },
        {
            path: 'sage/sage-efectos',
            name: 'sage-efectos',
            component: Efectos
        },
        {
            path: 'sage/sage-clientes',
            name: 'sage-clientes',
            component: Clientes
        },*/

        {
            path: 'informes/ventas/vales-clientes',
            name: 'vales-clientes',
            component: Vales
        },


    ]
}



// WEBPACK FOOTER //
// ./src/routes/informes.js